import { render } from "./stronaGlownaBody.vue?vue&type=template&id=00d71732&scoped=true"
import script from "./stronaGlownaBody.vue?vue&type=script&lang=js"
export * from "./stronaGlownaBody.vue?vue&type=script&lang=js"

import "./stronaGlownaBody.vue?vue&type=style&index=0&id=00d71732&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00d71732"]])

export default __exports__